import { breakpoints, InfoButton, Inline, Stack, Text, textColors, textVariants, vars } from '@etg/wings';
import { ContentWrapper, ScreenReaderPrice } from '@eti/components';
import { price as priceUtils } from '@eti/utils';
import { css } from '@eti/styles';
import { useMediaQuery } from 'usehooks-ts';
import { useProperty, useTranslation } from '@eti/providers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const mobileButtonContainerStyles = css`
  background-color: ${vars.colors.surface.primary};
  height: 40px;
  width: 100%;
`;
const contentWrapperStyles = css`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: space-between;
`;
const mobileStyles = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const {
  formatPrice,
  getPriceDivided
} = priceUtils;
const dividedPrice = (combinedExtraServicesPrice, numberOfTravelersWithoutInfants) => getPriceDivided(combinedExtraServicesPrice, numberOfTravelersWithoutInfants) || 0;
const EtgFaresPrice = ({
  handlePriceModalOpen,
  includedInTripProductPrice,
  numberOfTravelersWithoutInfants,
  selectedBundlePrice,
  totalTripPrice,
  tripPricePerAdult
}) => {
  const {
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints._768})`);
  const pricePerTraveler = p('Bundle.Overlay.Price.Per.Person.Enabled');
  const priceText = pricePerTraveler ? t('Price.Per.Person') : t('Product.FlexibleTicket.Bundle.Price.Text');
  const priceTextMobile = t('Product.ETG.Fares.Person.Text');
  const infoButtonLabel = t('ScreenReader.PriceSpecification.InfoButton');
  const combinedExtraServicesPrice = includedInTripProductPrice + selectedBundlePrice;
  const totalPrice = pricePerTraveler ? tripPricePerAdult + dividedPrice(combinedExtraServicesPrice, numberOfTravelersWithoutInfants) : totalTripPrice + combinedExtraServicesPrice;
  return isDesktop ? /*#__PURE__*/_jsxs(Stack, {
    align: "end",
    "aria-labelledby": "totalPriceText priceToPay priceToPayText",
    "data-testid": "etg-fares-desktop-price",
    spacing: 0,
    children: [/*#__PURE__*/_jsxs(Inline, {
      spacing: 4,
      children: [/*#__PURE__*/_jsx(InfoButton, {
        label: infoButtonLabel,
        onClick: handlePriceModalOpen
      }), /*#__PURE__*/_jsx(Text, {
        "aria-hidden": "true",
        variant: textVariants._24_EMPHASIZED,
        children: formatPrice(totalPrice)
      }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
        id: "priceToPay",
        price: formatPrice(totalPrice)
      })]
    }), /*#__PURE__*/_jsx(Text, {
      "aria-hidden": "true",
      color: textColors.SECONDARY,
      id: "priceToPayText",
      children: priceText
    })]
  }) : /*#__PURE__*/_jsx(Inline, {
    "aria-labelledby": "totalPriceText priceToPay priceToPayText",
    className: mobileButtonContainerStyles,
    noWrap: true,
    spacing: 8,
    children: /*#__PURE__*/_jsx(ContentWrapper, {
      className: contentWrapperStyles,
      children: /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        className: mobileStyles,
        "data-testid": "etg-fares-mobile-price",
        spacing: 0,
        children: [/*#__PURE__*/_jsxs(Inline, {
          alignY: "center",
          spacing: 4,
          children: [/*#__PURE__*/_jsx(Text, {
            "aria-hidden": "true",
            id: "totalPriceText",
            children: t('Product.ETG.Fares.Total.Price')
          }), /*#__PURE__*/_jsx(InfoButton, {
            label: infoButtonLabel,
            onClick: handlePriceModalOpen
          })]
        }), /*#__PURE__*/_jsxs(Inline, {
          alignY: "center",
          spacing: 4,
          children: [/*#__PURE__*/_jsx(Text, {
            "aria-hidden": "true",
            variant: textVariants._18_EMPHASIZED,
            children: formatPrice(totalPrice)
          }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
            id: "priceToPay",
            price: formatPrice(totalPrice)
          }), /*#__PURE__*/_jsx(Text, {
            "aria-hidden": "true",
            color: textColors.SECONDARY,
            id: "priceToPayText",
            children: pricePerTraveler ? priceTextMobile : ''
          })]
        })]
      })
    })
  });
};
export default EtgFaresPrice;
//# sourceMappingURL=EtgFaresPrice.js.map